export const setPreviousPseudoUrl = () => {
  const currentState = window.history.state || {};

  window.history.pushState({ baseUrl: currentState.baseUrl }, '', currentState.prevUrl || currentState.baseUrl || '/');
};
